import Api from './api.js'

function reportClick(path, issue, openid) {
  // Api.post('/couple/report_click_for_cp_h5', {path: path, issue: issue, openid: openid}, res => {
  //   if(res.code == 200){
  //     console.log('reportClick')
  //   }
  // })
}

export default {
  submit: function (path, issue, openid) {
    return reportClick(path, issue, openid)
  }
}
